export const SmartSendProvider = 'SMARTSEND';
export const Parcel2GoProvider = 'PARCEL2GO';
export const RoyalMailProvider = 'RMOBA';

export const QuoteProviderOptions = [SmartSendProvider, Parcel2GoProvider, RoyalMailProvider] as const;
export type QuoteProvider = (typeof QuoteProviderOptions)[number];
export const IsQuoteProvider = (provider: string) => QuoteProviderOptions.includes(provider as QuoteProvider);
